import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { DueDate } from "./date-picker";
import { updateTask as updateTaskAction, DatosPorsentaje as datos } from "../../store/grupo.actions";
import { handleResponsable } from "../../store/user.actions";
import { userService } from '../../services/user.service';

import { Resizable, ResizableBox } from "react-resizable";
import { boardService } from "../../services/board.service";
import { MemberPicker } from "./member-picker";
import { PriorityPicker } from "./priority-picker";
import { StatusPicker } from "./status-picker";
import { setDynamicModalObj, toggleModal } from "../../store/board.actions";
import { UpdatedPicker } from "./updated-picker";
import { NumberPicker } from "./number-picker";
import { ProjectPicker } from "./project-picker";

import { ProgressCalculator } from "./porsetaje-picker"; // Importa el componente

import { FilePicker } from "./file-picker";
import { TextPicker } from "./text-picker";

import { TbArrowsDiagonal } from 'react-icons/tb';
import { BiDotsHorizontalRounded, BiMessageRoundedAdd, BiChevronDown, BiChevronRight } from 'react-icons/bi';
import { HiOutlineChatBubbleOvalLeft } from 'react-icons/hi2';

import NoteModal from '../../cmps/modal/modal-task-editor';

// import Tooltip from '@mui/material/Tooltip'; // Importa Tooltip desde Material-UI
// import { Typography } from '@mui/material'; // Puedes importar otros componentes de Material-UI según sea necesario
import '../../assets/styles/tooptios.css';
import{ROLES}from '../../services/user.service'


import { SubItemsPreview } from "../board/subitems-preview";

export function TaskPreview({ width, width2, usuarios, task, group, board, handleCheckboxChange, isMainCheckbox, customHeight }) {
    const lineHeight = customHeight;
    const [taskToEdit, setTaskToEdit] = useState(task);
    const [isTyping, setIsTyping] = useState(false);

    const [RespToEdit, setRestEdit] = useState(task.responsable);
    const [isClick, setIsClick] = useState(false);
    const [showSubitems, setShowSubitems] = useState(false);

    const isOpen = useSelector((storeState) => storeState.boardModule.isBoardModalOpen);
    const [user, setUser] = useState(userService.getLoggedinUser().data.data); //Usuario logueado en la interfaz
    const dynamicModalObj = useSelector(storeState => storeState.boardModule.dynamicModalObj);
    const elTaskPreview = useRef(null);
    const elMenuTask = useRef();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentField, setCurrentField] = useState('');
    const [fileCount, setFileCount] = useState(0); // Estado para contar los archivos

    // Función para abrir el modal con el campo específico
    const toggleModal = (field) => {setCurrentField(field); setIsModalOpen(!isModalOpen);};

    const isEditable = user.rol === ROLES.ADMIN

    const isEditableSpecific = user.rol === ROLES.TECNICO || user.rol === ROLES.ADMIN;

    const guest = "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png";

     // Formatear la fecha para obtener año, mes, día y hora
     const date = new Date(taskToEdit.updated_at);
     const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;

   
    useEffect(() => {
        setIsClick(isMainCheckbox.isActive);
    }, [isMainCheckbox,fileCount]);

    async function onUpdateTask(ev, field, number) {
        ev.preventDefault();

        // Actualiza el campo específico en taskToEdit
        const updatedTask = {
            ...taskToEdit,
            [field]: number
        };

        // Actualiza el estado con los nuevos detalles de la tarea

        // Prepara updatedTask para actualizar en el backend
        const taskForUpdate = {
            ...updatedTask,
            // fk_proyecto_id: 1,
            fk_grupo_id: group.id_grupo,
            updated_at: new Date().toISOString()
        };

        
        try {
            await updateTaskAction(taskForUpdate); // Función para actualizar la tarea en el backend
            setTaskToEdit(taskForUpdate);
        } catch (err) {
            console.error('Error al actualizar la tarea:', err);
        }
    }

    function handleInputChange(ev, field) {
        setIsTyping(false);
        onUpdateTask(ev, field, ev.target.innerText);
    }

    function toggleSubitems() {
        setShowSubitems(!showSubitems);
    }

    function onOpenModal() {
        toggleModal(isOpen);
        navigate(`/board/${board._id}/${group.id_grupo}/${task.id_actividad}`);
    }

    function onCheckBoxChange() {
        handleCheckboxChange(task);
        setIsClick(!isClick);
    }

    function onToggleTaskModal() {
        const isOpen = dynamicModalObj?.task?.id === task.id && dynamicModalObj?.type === 'menu-task' ? !dynamicModalObj.isOpen : true;
        const { x, y, height } = elMenuTask.current.getClientRects()[0];
        setDynamicModalObj({ isOpen, pos: { x: (x - 10), y: (y + height) }, type: 'menu-task', group: group, task: task });
    }

    function toggleOnTyping() {
        setIsTyping(true);
        elMenuTask.current.classList.toggle('on-typing');
        elTaskPreview.current.classList.toggle('on-typing');
    }



    function conteofiledata(conteoactualizado){
        
        setFileCount(conteoactualizado);
        console.log(fileCount);
    }
    

    function handleUpdateMembers(idActividad, idField, idResponsable, mode) {
        const newResponsable = {
            ...RespToEdit,
            [idField]: idActividad,
            fk_usuario_id: idResponsable,
        };
        setRestEdit(newResponsable);

        handleResponsable(newResponsable, mode);
    };

    


    return (
        <section>
            <div className={'task-preview flex'} ref={elTaskPreview} style={{height:lineHeight}} >

           
                <div ref={elMenuTask} className="sticky-div" style={{ borderColor: group.color }}>
                    <div className="task-menu" >
                        {/* <BiDotsHorizontalRounded className="icon" onClick={onToggleTaskModal} /> */}
                        <BiDotsHorizontalRounded className="icon"/>
                    </div>

                <div className="check-box" style={{ pointerEvents: isEditable ? 'auto' : 'none', opacity: isEditable ? 1 : 0.5 }}>
                        <input type="checkbox" checked={isClick} onChange={onCheckBoxChange} disabled={!isEditable} />
                    </div>


                    <div ref={elMenuTask} style={{ borderColor: group.color ,zIndex:5000, height:lineHeight}} className="tooltip-container" >
                        <div className="task-title picker flex align-center space-between" style={{ width: '500px', overflowY: "auto", height:lineHeight}}>
                            <div className="" style={{ display: 'flex' }} onClick={toggleSubitems}>
                                {!showSubitems && <BiChevronRight size={22} />}
                                {showSubitems && <BiChevronDown size={22} />}
                            </div>
                            
                            <blockquote
                                contentEditable={isEditable} 
                                
                                onFocus={toggleOnTyping}
                                onBlur={(ev) => handleInputChange(ev, 'descripcion')}
                                suppressContentEditableWarning={true}
                                style={{ marginLeft: "7px", width: '470px', whiteSpace:"pre-wrap", cursor: isEditable ? 'pointer' : 'not-allowed'}}
                            >
                            {taskToEdit.descripcion}
                            </blockquote>
                            {/* <div className="open-task-details " onClick={onOpenModal}>
                                <TbArrowsDiagonal size={18}/>
                                <span className="open-btn" style={{ marginLeft: "3px" }}>Abrir</span>
                            </div> */}
                            <div>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '2px 7px',
                                    backgroundColor: task.subactividades !== undefined && task.subactividades.length > 0 ? '#e0e0e0' : '#fdab3d',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    borderRadius: '5px',}}>
                                        {
                                            task.subactividades !== undefined ? task.subactividades.length : 0
                                        }
                                </span>
                            </div>

                      
                            {!isTyping && 
                                <div className="tooltip-text">
                                    {/* {taskToEdit.descripcion} */}
                                </div>
                            } 

                <div className="open-task-details" onClick={() => toggleModal('descripcion')} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <TbArrowsDiagonal size={15} />
                    <span className="open-btn" style={{ marginLeft: "3px" }}>Abrir</span>
                </div>
            </div>
                <NoteModal isOpen={isModalOpen && currentField === 'descripcion'} onClose={() => setIsModalOpen(false)} initialText={taskToEdit.descripcion} onSave={onUpdateTask} field="descripcion" />
        </div>

    </div>

                
                <div  style={{ borderColor: group.color}} className="tooltip-container">
                    <div className="task-title picker flex align-center space-between" style={{ width: "249px", height:lineHeight }}>
                        <blockquote 
                             contentEditable={isEditable} 
                            onFocus={toggleOnTyping}
                            onBlur={(ev) => handleInputChange(ev, 'medio_verificacion')}
                            suppressContentEditableWarning={true}
                            style={{ textAlign:"center", width: "220px",whiteSpace:"pre-wrap",  cursor: isEditable ? 'pointer' : 'not-allowed' }}>
                                
                            {taskToEdit.medio_verificacion}
                        </blockquote>
                    </div>
                    {!isTyping && <div className="tooltip-text">
                        {taskToEdit.medio_verificacion}
                    </div>
                    }
                    
                </div>


                <div ref={elMenuTask} style={{ borderColor: group.color, width:"230px !important", height:lineHeight}}>
                    <MemberPicker customHeight={customHeight} info={{ id_actividad: task.id_actividad, idField:"fk_actividad_id", campo:"task-preview" }} responsables={RespToEdit} onUpdate={handleUpdateMembers}   userRol={user.rol}  />
                    {/* <div className="picker flex align-center space-between" style={{width:"50px"}}>
                    </div> */}
                </div>


                <DueDate customHeight={customHeight} style={{height:lineHeight}} info={{ date: taskToEdit.fecha_inicio, campo:"task-preview" }} field="fecha_inicio" onUpdate={onUpdateTask} userRol={user.rol} />
                <DueDate customHeight={customHeight} info={{ date: taskToEdit.fecha_final, campo:"task-preview" }} field="fecha_final" onUpdate={onUpdateTask} userRol={user.rol} />

                <NumberPicker customHeight={customHeight} info={{ number: taskToEdit.meta }} field="meta" onUpdate={onUpdateTask} userRol={user.rol}/>
                <NumberPicker customHeight={customHeight} info={{ number: taskToEdit.ejecucion }} field="ejecucion" onUpdate={onUpdateTask} userRol={user.rol} />

                
                    
                <ProgressCalculator customHeight={customHeight} meta={taskToEdit.meta} ejecucion={taskToEdit.ejecucion} userRol={user.rol} />
                            
                       
                <div ref={elMenuTask} style={{ borderColor: group.color, width:"170px", height:lineHeight}}>
                <StatusPicker customHeight={customHeight} info={{ campo:"task-preview", estado: taskToEdit.fk_estado_id, avancesDescripcion: taskToEdit.avances, cantidadArchivos: task.archivosactividad?.length || fileCount || 0}} field="fk_estado_id" onUpdate={onUpdateTask} userRol={user.rol} />
                
                </div>

                <div ref={elMenuTask} style={{ borderColor: group.color, width:"170px", height:lineHeight}}>
                    <ProjectPicker customHeight={customHeight} info={{ idproyecto: taskToEdit.fk_proyecto_id }} field="fk_proyecto_id" onUpdate={onUpdateTask}  userRol={user.rol}/>
                </div>

                
                <FilePicker customHeight={customHeight} info={{name_grupo:group.nombre_grupo, id_actividad: task.id_actividad, id_carpeta_drive: task.id_carpeta_drive}} files ={task.archivosactividad} counterFile={conteofiledata} userRol={user.rol}/>


            <div style={{ borderColor: group.color }} className="tooltip-container">
                <div className="task-title picker flex align-center space-between" style={{ width: "380px", height: lineHeight }}>
                    <blockquote
                        contentEditable={isEditableSpecific} // Usando isEditableSpecific
                        onFocus={toggleOnTyping}
                        onBlur={(ev) => handleInputChange(ev, 'avances')}
                        suppressContentEditableWarning={true}
                        style={{ marginLeft: "6px", width: "370px",textAlign: 'justify', whiteSpace: "pre-wrap", cursor: isEditableSpecific ? 'pointer' : 'not-allowed' }} // Usando isEditableSpecific
                    >
                        {taskToEdit.avances}
                    </blockquote>


                    {!isTyping && (
                        <div className="tooltip-text">
                            {/* {taskToEdit.avances} */}
                        </div>
                    )}

                <div className="open-task-details" onClick={() => toggleModal('avances')} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <TbArrowsDiagonal size={15} />
                    <span className="open-btn" style={{ marginLeft: "3px" }}>Abrir</span>
                </div>
                    
                </div>

                {/* <NoteModal isOpen={isModalOpen} onClose={toggleModal} initialText={taskToEdit.avances} onSave={onUpdateTask} field="avances"  /> */}
                
                <NoteModal isOpen={isModalOpen && currentField === 'avances'} onClose={() => setIsModalOpen(false)} initialText={taskToEdit.avances} onSave={onUpdateTask} field="avances"/>
            
            </div>
                    {/* identificador carpeta drive */}
                    {isEditable && (
                <div style={{ borderColor: group.color }} className="tooltip-container">
                    <div className="task-title picker flex align-center space-between"style={{ width: "250px", height: lineHeight }}>
                    <blockquote
                        contentEditable={isEditable}
                        onFocus={toggleOnTyping}
                        onBlur={(ev) => handleInputChange(ev, 'id_carpeta_drive')}
                        suppressContentEditableWarning={true}
                        style={{
                        marginLeft: "2px",
                        textAlign: "center",
                        width: "250px",
                        whiteSpace: "pre-wrap",
                        cursor: isEditable ? 'pointer' : 'not-allowed',
                        }}
                    >
                        {taskToEdit.id_carpeta_drive}
                    </blockquote>
                    </div>
                </div>
                )}


            {/* fecha de moficicacion */}
            {isEditable && (
            <div style={{ borderColor: group.color }} className="tooltip-container">
                <div className="task-title picker flex align-center space-between" style={{ width: "180px", height: lineHeight }}>
                
                    <blockquote
                        contentEditable={false} // Usando isEditableSpecific
                        onFocus={toggleOnTyping}
                        // onBlur={(ev) => handleInputChange(ev, 'avances')}
                        suppressContentEditableWarning={true}
                        style={{ marginLeft: "6px", width: "180px", whiteSpace: "pre-wrap", cursor: isEditableSpecific ? 'pointer' : 'not-allowed' }} // Usando isEditableSpecific
                    >
                        {formattedDate}
                    </blockquote>
                  
                </div>
            </div>
        )}   
            <div className="empty-div" ></div>
            </div>

            <li key={1} hidden={!showSubitems}><SubItemsPreview customHeight={customHeight} subitems={task.subactividades} responsables={task.responsable} idx={1} group={group} board={board} id_actividad={task.id_actividad} /></li>
        </section>
    )
}

function DynamicCmp({ cmp, info, onUpdate }) {
    switch (cmp) {
        case "status-picker":
            return <StatusPicker info={info} onUpdate={onUpdate} />;
        case "member-picker":
            return <MemberPicker info={info} onUpdate={onUpdate} />;
        case "priority-picker":
            return <PriorityPicker info={info} onUpdate={onUpdate} />;
        case "updated-picker":
            return <UpdatedPicker info={info} onUpdate={onUpdate} />;
        case "file-picker":
            return <FilePicker info={info} onUpdate={onUpdate} />;
        case "number-picker":
            return <NumberPicker info={info} onUpdate={onUpdate} />;
        case "text-picker":
            return <TextPicker info={info} onUpdate={onUpdate} />;
        default:
            return null;
    }
}
